export const useImageLoadEvent = (image: Ref<HTMLImageElement | undefined>, callback: (image: HTMLImageElement) => void) => {
  watch(
    image,
    img => {
      if (!img) return

      img.addEventListener('load', function () {
        callback(img)
      })
    },
    { immediate: true }
  )
}
